import React, { useContext, useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Logo from "../../assets/logo.png";
import { UserContext } from "../../context/UserContext";
import { Chip } from "@mui/material";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Header({ drawerWidth, handleDrawerToggle }) {
	const { user } = useContext(UserContext);
	const navigate = useNavigate();
	const { t } = useTranslation();

	const getColorFromStatus = (status) => {
		switch (status) {
			case "inviting":
				return "#f1c40f";
			case "building":
				return "#3498db";
			case "built":
				return "#43BD98";
			case "rejected":
				return "#e74c3c";
			case "publishing":
				return "#3498db";
			case "published":
				return "#43BD98";
			default:
				return "#f1c40f";
		}
	};

	const location = useLocation();

	useEffect(() => {
		ReactGA.send({
			hitType: "pageview",
			page: window.location.href,
			title: "",
		});
	}, [location]);

	return (
		<Box sx={{ flexGrow: 1 }}>
			<AppBar
				color="secondary"
				elevation={0}
				position="fixed"
				sx={{
					width: {
						sx: "100%",
						sm: `calc(100% - ${drawerWidth}px)`,
						ml: `${drawerWidth}px`,
					},
				}}
			>
				<Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
					<Box sx={{ display: "flex", alignContent: "center" }}>
						<IconButton
							color="inherit"
							aria-label="open drawer"
							edge="start"
							onClick={handleDrawerToggle}
							sx={{ mr: 2, display: { sm: "none" } }}
						>
							<MenuIcon sx={{ color: "#262626" }} />
						</IconButton>

						<img src={Logo} alt="logo" style={{ width: 90 }} />
					</Box>

					<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
						<Typography
							sx={{ fontSize: 12, display: { xs: "none", sm: "block" } }}
						>
							{t("publish.appStatus") || ""}
						</Typography>
						<Chip
							label={t(
								"publish." +
									(user.app.appStatuses[0]?.status ?? "pending") +
									"Status"
							)}
							onClick={() => {
								navigate("/publish");
							}}
							sx={{
								backgroundColor: getColorFromStatus(
									user.app.appStatuses[0]?.status
								),
								color: "white",
								borderRadius: "30px",
								cursor: "pointer!important",
								"&:hover": {
									backgroundColor: getColorFromStatus(
										user.app.appStatuses[0]?.status
									),
									textDecoration: "underline",
								},
							}}
						></Chip>
					</Box>
				</Toolbar>
			</AppBar>
		</Box>
	);
}
